import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { Box, TextField } from '@mui/material';
import { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import * as actions from "../../store/actions/actionIndex";
import { localStorageFunc, notify } from '../../helpers/utility';
import WarningIcon from '@mui/icons-material/Warning';
import { useNavigate } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

function PasswordReset(props) {
  const { agentId, open, handleClose, responseCode, error, onChangePassword } = props;
  const [currentPassword, setCurrentPassword] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [validationError, setValidationError] = useState('');
  const [submit, setSubmit] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [countdown, setCountdown] = useState(5);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
const [showPassword, setShowPassword] = useState(false);
const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const checkKeycode = useCallback((e) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  }, [currentPassword, password, confirmPassword]);

  useEffect(() => {
    document.addEventListener('keydown', checkKeycode);
    return () => {
      document.removeEventListener('keydown', checkKeycode);
    };
  }, [checkKeycode]);

  const signOut = (history) => {
    if (
      props.agentState === "INCALL" ||
      props.agentState === "CLOSURE" ||
      props.agentState === "PREVIEW_FAIL"
    ) {
      notify("CRM Error: Please Disconnect the Call", "crm-error");
    } else {
      history.push("/logout");
    }
  };

  // useEffect(() => {
  //   if (responseCode === "1" && props.soonExpired === false) {
  //     setSuccessMessage(props.reason);
  //     setTimeout(() => {
  //       window.location.reload(false);
  //     }, 3000);
  //   }
  //   else if (responseCode === "1" && props.soonExpired === true) {
  //     setSuccessMessage(props.reason);
  //     setTimeout(() => {
  //       signOut(props.history);
  //     }, 3000);
  //   }
  // }, [responseCode, error, submit, props.reason, props.soonExpired]);

  useEffect(() => {
    let timer;
    if (responseCode === "1") {
      setSuccessMessage(props.reason);
      setCountdown(5); 
      timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            if (props.soonExpired) {
              signOut(props.history); 
            } else {
              window.location.reload(); 
            }
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [responseCode, props.soonExpired, props.reason, props.history]);
  const handleSubmit = () => {
    if (!currentPassword) {
      setValidationError('Current password is required.');
      return;
    }
    if (!password) {
      setValidationError('New password is required.');
      return;
    }
    if (!confirmPassword) {
      setValidationError('Confirm password is required.');
      return;
    }
    if (password !== confirmPassword) {
      setValidationError('Passwords do not match.');
      return;
    }
    setValidationError('');
    onChangePassword(agentId, currentPassword, password, confirmPassword);
    setSubmit(true);
  };

  // Done Button
  const handleDoneClick = () => {
    if (props.soonExpired) {
      signOut(props.history); 
    } else {
      window.location.reload(); 
    }
  };
  const handleDialogClose = () => {
    setCurrentPassword('');
    setPassword('');
    setConfirmPassword('');
    setValidationError('');
    setSubmit(false);
    setSuccessMessage('');
    setCountdown(5);
    setShowCurrentPassword(false);
    setShowPassword(false);
    setShowConfirmPassword(false);
    props.handleClose(); 
  };

  return (
    <BootstrapDialog aria-labelledby="customized-dialog-title" open={open}>
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        Reset Password
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleDialogClose}
        sx={{
          position: 'absolute',
          insetInlineEnd: 8,
          top: 8,
          color: 'grey.500',
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ maxWidth: '500px' }}>
      {successMessage ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
              }}
            >
              <CheckCircleIcon sx={{ fontSize: 40, color: '#4caf50', mb: 1 }} />
              <Typography  variant="h6" sx={{  mb: 1 , color: '#4caf50'}}>
               {props.reason}
              </Typography>
              <Typography variant="body1" sx={{ color: '#757575', mb: 3 }}>
                Your agent password has been updated. You'll be using your new password for future logins.
              </Typography>
              <Button
                variant="contained"
                color="success"
                onClick={handleDoneClick}
                sx={{ width: '100%', py: 1 }}
              >
                Done ({countdown})
              </Button>
            </Box>
          ):(
        <Box
          sx={{
            mb: 1,
            p: 2,
            bgcolor: "#fff9c4",
            border: "1px solid",
            borderColor:  "#ffd54f",
            borderRadius: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            textAlign: successMessage ? "center" : "start",
          }}
        >
            <>
              <WarningIcon color="warning" fontSize="medium" />
              <Typography variant="body1" sx={{ fontWeight: "medium", color: "#e65100", ml: 1 }}>
                {props.soonExpired === false
                  ? "Your password has expired, please create a new password."
                  : "Your password will expire soon, please update it."}
              </Typography>
            </>
        </Box>
  )}

        {/* Hide inputs and button on success */}
        {!successMessage && (
          <>
           <TextField
  fullWidth
  label="Current Password"
  type={showCurrentPassword ? 'text' : 'password'}
  margin="normal"
  variant="outlined"
  value={currentPassword}
  onChange={(e) => setCurrentPassword(e.target.value)}
  InputProps={{
    endAdornment: (
      <InputAdornment position="end">
        <IconButton
          onClick={() => setShowCurrentPassword(!showCurrentPassword)}
          edge="end"
        >
          {showCurrentPassword ? <Visibility /> : <VisibilityOff />}
        </IconButton>
      </InputAdornment>
    ),
  }}
/>

<TextField
  fullWidth
  label="New Password"
  type={showPassword ? 'text' : 'password'}
  margin="normal"
  variant="outlined"
  value={password}
  onChange={(e) => setPassword(e.target.value)}
  InputProps={{
    endAdornment: (
      <InputAdornment position="end">
        <IconButton
          onClick={() => setShowPassword(!showPassword)}
          edge="end"
        >
          {showPassword ? <Visibility /> : <VisibilityOff />}
        </IconButton>
      </InputAdornment>
    ),
  }}
/>

<TextField
  fullWidth
  label="Confirm Password"
  type={showConfirmPassword ? 'text' : 'password'}
  margin="normal"
  variant="outlined"
  value={confirmPassword}
  onChange={(e) => setConfirmPassword(e.target.value)}
  InputProps={{
    endAdornment: (
      <InputAdornment position="end">
        <IconButton
          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          edge="end"
        >
          {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
        </IconButton>
      </InputAdornment>
    ),
  }}
/>

            {validationError && <Typography color="error" variant="body2">{validationError}</Typography>}
          </>
        )}
      </DialogContent>

      {!successMessage && (
        <DialogActions>
          <Button
            autoFocus
            onClick={handleSubmit}
            variant="contained"
            color="primary"
            fullWidth
            sx={{ py: 1 }}
          >
            Save changes
          </Button>
        </DialogActions>
      )}
    </BootstrapDialog>
  );
}

const mapStateToProps = (state) => ({
  error: state.resetData.error,
  responseCode: state.resetData.responseCode,
  agentState: state.agentData.agentState,
  isExpired: state.resetData.isExpired,
  loading: state.resetData.loading,
  reason: state.resetData.reason
});

const mapDispatchToProps = (dispatch) => ({
  onChangePassword: (email, currPassword, newPassword, confirmPassword) =>
    dispatch(actions.changeAgentPassword(email, currPassword, newPassword, confirmPassword)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PasswordReset);
